import "../../design/about.css";
import { Button } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { goToLinkWithNewTab } from "../../helper/changeLocation";
import aboutFirstImage from "../../assets/about/aboutFirstImage.avif";
import aboutSecondImage from "../../assets/about/aboutSecondImage.avif";

export default function About() {
    return (
        <section id="about" className="aboutSection">
            <div className="aboutContainer">
                {/* SECTION HEADER */}
                <motion.div
                    className="cyberSectionHeader"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    <span className="sectionTag">SYSTEM_SPECS</span>
                    <h2>ABOUT <span className="gradientText">DEVELOPER</span></h2>
                </motion.div>

                {/* ===== ROW 1: EDUCATION & SKILLS ===== */}
                <div className="aboutRow">
                    <motion.div
                        className="aboutCard glass-panel"
                        initial={{ opacity: 0, x: -40 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        <h3>Education & Competencies</h3>
                        <div className="aboutList">
                            <p>• Ranked Top 150 globally on <a href="https://eolymp.com/en/users/OtarMurmanishvili" target="_blank" rel="noreferrer">e-olymp.com</a> with 1000+ C++ algorithm solutions.</p>
                            <p>• Advanced frontend ecosystem mastery using <strong>React</strong>.</p>
                            <p>• Microservices & API backend engineering via <strong>Node.js</strong> & <strong>Java</strong>.</p>
                            <p>• Enterprise relational schema architecture in <strong>PostgreSQL</strong>.</p>
                            <p>• Preferred Stack: <strong>React, Node.js, PostgreSQL, C++</strong>.</p>
                        </div>
                    </motion.div>

                    <motion.div
                        className="aboutVisual"
                        initial={{ opacity: 0, x: 40 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        <div className="cyberImageFrame">
                            <img src={aboutSecondImage} alt="Education visual" />
                        </div>
                    </motion.div>
                </div>

                {/* ===== ROW 2: EXPERIENCE & DIPLOMAS ===== */}
                <div className="aboutRow rowReverse">
                    <motion.div
                        className="aboutVisual"
                        initial={{ opacity: 0, x: -40 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        <div className="cyberImageFrame">
                            <img src={aboutFirstImage} alt="Experience visual" />
                        </div>
                    </motion.div>

                    <motion.div
                        className="aboutCard glass-panel"
                        initial={{ opacity: 0, x: 40 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        <h3>Industry Experience</h3>
                        <div className="aboutList">
                            <p>• Delivered full-stack production systems from initial architecture to live launch.</p>
                            <p>• Designed modular, reusable UI & system patterns to optimize development cycles.</p>
                            <p>• Applied clean architecture & microservices principles for high-load reliability.</p>
                            <p>• Engineered commercial applications driving real-world revenue execution.</p>
                            <p>• Mentored developers in <strong>C++ Data Structures & Algorithms</strong>.</p>
                        </div>

                        <Button
                            className="cyberButton"
                            onClick={() =>
                                goToLinkWithNewTab(
                                    "https://drive.google.com/drive/folders/1ntb7uv8ei_NsIVT5tO3fI25Eq-LJzbgX?usp=sharing"
                                )
                            }
                        >
                            VERIFY DIPLOMAS & CERTIFICATES
                        </Button>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}